/**
 * Toggle an industry-code node and cascade selection to children / parents.
 * Kept at module scope so callers inside MobX observables stay under Sonar’s
 * max nested-function depth (S2004).
 *
 * @param {Array<{value: string, selected?: boolean, parent?: {value: string}, children?: unknown[]}>} industryCodesFlat
 * @param {{value: string}} code
 */
export const toggleIndustryCodeSelection = (industryCodesFlat, code) => {
  const targetNode = industryCodesFlat.find((c) => c.value === code.value);
  if (!targetNode) return;

  targetNode.selected = !targetNode.selected;

  const nodeMap = new Map();
  industryCodesFlat.forEach((node) => nodeMap.set(node.value, node));

  const processChildren = (nodeValue, selected) => {
    const node = nodeMap.get(nodeValue);
    if (!node) return;

    node.selected = selected;

    industryCodesFlat
      .filter((c) => c.parent?.value === nodeValue)
      .forEach((child) => processChildren(child.value, selected));
  };

  if (targetNode.children?.length) {
    targetNode.children.forEach((child) => {
      processChildren(child.value, targetNode.selected);
    });
  }

  const updateParents = (nodeValue) => {
    const node = nodeMap.get(nodeValue);
    if (!node?.parent) return;

    const parent = nodeMap.get(node.parent.value);
    if (!parent) return;

    parent.selected = industryCodesFlat
      .filter((c) => c.parent?.value === parent.value)
      .every((c) => c.selected);

    if (parent.parent) {
      updateParents(parent.value);
    }
  };

  updateParents(code.value);
};
